import React from "react";
import TabsBox from "../../../../components/Tabs";
import { ADMIN_ROUTES } from "../../../../constants/appRoutes";

const CategoryPageLayout = ({ children }: { children: React.ReactNode }) => {
  const categoryTabsList = [
    {
      title: "Main Category",
      url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.CATEGORY_MAIN_CATEGORIES}`,
    },
    {
      title: "Sub Category",
      url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.CATEGORY_MAIN_SUB_CATEGORIES}`,
    },
  ];
  return <TabsBox asLink={categoryTabsList}>{children}</TabsBox>;
};

export default CategoryPageLayout;
